import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudflareService } from '../../service';

export type TlsSettingsExportConfig = typeof TlsSettingsExportConfig._.Config;

export const TlsSettingsExportConfig = IntegrationConfig.make({
  service: CloudflareService,
  name: Integration_Handler_Names_Enum.TlsSettingsExport,
  configSchema: z.object({
    zoneId: z.string().min(1),
  }),
});
